import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  BASE_URL,
  dropdownFetch,
  getDateDifference,
  getKeyPathValue,
  request,
  toast
} from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { ArtificialManualOverrideTable } from './ArtificialManualOverrideTable';
import axios from 'axios';
import { debounce } from "lodash";


function formatDate(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

const BILL_TABLE_HEADER = [
  {
    header: 'Diagnos',
    accessor: (row) => row?.serviceData.service_name
  },
  {
    header: 'No. Of Patient',
    accessor: ''
  },
  {
    header: 'Ipd Charge',
    accessor: ''
  },
];

const TABLE_HEADER = [
  {
    header: 'Diagnosis ',
    accessor: ''
  },
  {
    header: 'No. Of Patient',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.patient_name}`}
        </span>
      );
    }
  },
  {
    header: 'Time From',
    accessor: ''
  },
  {
    header: 'Time To',
    accessor: ''
  },

];

const initialDischargeSummaryDataObj = {
  data: [],
  loading: false
};

export const IpdArtificialManualOverride = () => {
  const doctorIDRef = useRef();
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [dischargeSummaryObj, setDischargeSummaryObj] = useState(initialDischargeSummaryDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [medicineDetailList, setmedicineDetailList] = useState([]);
  const [diagnos, setDiagnos] = useState([]);
  const [dischargeSummaryData, setDischargeSummaryData] = useState([]);
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [unitDropdown, setUnitDropdown] = useState([])
  const [selectedRows, setSelectedRows] = useState([]);
  const [issLoading, setIssLoading] = useState(false)
  const [serviceDropdown, setServiceDropdown] = useState([])
  const [selectedDepartmentCheck, setSelectedDepartmentCheck] = useState(false);
  const [selectedSearchCheak, setSelectedSearchCheak] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [error, setError] = useState(null)
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 10
  });
  const [input, setInput] = useState('')


  const user = JSON.parse(localStorage.getItem('user'));

  const isEnabledDate =
    user && user.permissions ? user.permissions.some((permission) => permission.includes('DatePermission')) : false;


  const [doctorDropdown, setDoctorDropdown] = useState([]);

  const getDoctorDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor');
    setDoctorDropdown(data);
  }, []);

  const getDepartmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('department');
    setDepartmentDropdown(data);
  }, []);

  const getDoctorUnitDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor-unit');
    setUnitDropdown(data);
  }, []);


  useEffect(() => {
    getDoctorDropdown();
    getDepartmentDropdown();
    getDoctorUnitDropdown()
  }, [getDoctorDropdown, getDepartmentDropdown, getDoctorUnitDropdown]);

  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {
      date: new Date().toISOString().split('T')[0]
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, '', [
        '_id',
        '__v',
        'status',
        'createdAt',
        'beds',
        'medicine'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      const formattedRegDate = selectedRecord?.date ? new Date(selectedRecord.date).toISOString().split('T')[0] : '';
      setValue('date', formattedRegDate);
      setDiagnos(selectedRecord.diagnos);
      setmedicineDetailList(selectedRecord.medicine);
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/' : '/', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...formValues,
        medicine: medicineDetailList,
        diagnos: diagnos,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    console.table(response, 'HELLO DATA');
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Discharge Summary`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      setmedicineDetailList([]);
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Discharge Summary`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setDischargeSummaryObj({ loading: true });
    const response = await request('/', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setDischargeSummaryObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setDischargeSummaryObj({ loading: false });
    }
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancel Indoor Registeration', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to Cancel Indoor Registeration', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Indoor Registeration', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Indoor Registeration', { variant: 'error' });
    }
    setLoading(false);
  };

  const dobWatch = watch('dob');
  useEffect(() => {
    if (!dobWatch) return;
    const dobDate = new Date(dobWatch);
    if (dobDate >= Date.now()) {
      toast('DOB cannot be of future', { variant: 'error' });
      return;
    }
    const { year, month, day } = getDateDifference(new Date(dobWatch));
    setValue('age_year', year);
  }, [setValue, dobWatch]);


  const getServiceData = useCallback(
    async (currentPage, selectedDepartment) => {
      if (selectedDepartmentCheck) {
        setIssLoading(true);
        try {
          const response = await axios.get(
            `${BASE_URL}/artificial-price-list-master/list?page=${currentPage}&departmentName=${selectedDepartment}`
          );
          const { data: newData, pagination: newPagination } = response.data;
          setServiceDropdown((prevData) => [...prevData, ...newData]);
          setPagination(newPagination);
        } catch (error) {
          console.error('Error fetching service data:', error);
        } finally {
          setIssLoading(false);
        }
      }
    },
    [selectedDepartmentCheck]
  );

  const fetchMoreData = (currentPage, selectedDepartment) => {
    if (!issLoading) {
      console.log("hello");
      getServiceData(currentPage,selectedDepartment);
    }
  };

  useEffect(() => {
    fetchMoreData(1, selectedDepartment,);
  }, [selectedDepartment]);


  const isSelected = (row, field) => {
    const selectedRow = selectedRows.find((selectedRow) => selectedRow._id === row._id);
    return selectedRow ? selectedRow[field] : false;
  };

  const handleRowSelect = (row, field) => {
    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === row._id);

      if (existingRow) {
        // Toggle selection state
        return prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id);
      } else {
        // Add row to the selectedRows
        return [...prevSelectedRows, { ...row, [field]: true }];
      }
    });
  };

  const handleInputChange = (e, rowId, header) => {
    const { value } = e.target;

    // Update the main data source
    setServiceDropdown((prevData) =>
      prevData.map((row) =>
        row._id === rowId
          ? {
            ...row,
            inputValues: row.inputValues.map((inputValue) =>
              inputValue.hasOwnProperty(header) ? { ...inputValue, [header]: value } : inputValue
            )
          }
          : row
      )
    );

    // Ensure selectedRows also reflects the updated value
    setSelectedRows((prevSelectedRows) =>
      prevSelectedRows.map((row) =>
        row._id === rowId
          ? {
            ...row,
            inputValues: row.inputValues.map((inputValue) =>
              inputValue.hasOwnProperty(header) ? { ...inputValue, [header]: value } : inputValue
            )
          }
          : row
      )
    );
  };

  const departmentWatch = watch('department')

  const getServiceDropdownn = useCallback(

    debounce(async (currentPage, selectedDepartment, input) => {
      
      if (selectedDepartmentCheck && selectedSearchCheak) {
        setIssLoading(true);
        setError(null);
        try {
          const response = await axios.get(
            `${BASE_URL}/artificial-price-list-master/list?page=${currentPage}&departmentName=${selectedDepartment}&serviceName=${input}`
          );
          const { data: newData, pagination: newPagination } = response.data;

          
          setServiceDropdown((prevData) => [...prevData, ...newData]);
          setPagination(newPagination);
        } catch (err) {
          console.error('Error fetching service data:', err);
          setError('An error occurred while fetching service data.');
        } finally {
          setIssLoading(false);
        }
      }
    }, 500),
    [selectedDepartmentCheck,selectedSearchCheak]
  );


  const fetchMoreDataSearch = (currentPage, selectedDepartment, input) => {
    console.log(selectedSearchCheak)
    console.log(issLoading)
    console.log(selectedDepartmentCheck)
    if (!issLoading) {
      getServiceDropdownn(currentPage, selectedDepartment, input);
    }
  };


  useEffect(() => {
    setServiceDropdown([]);
    fetchMoreDataSearch(1, selectedDepartment, input);
  }, [input, selectedDepartment]);


  const handleChange = (e) => {
    console.log(e.target.value);
    setInput(e.target.value);
    setSelectedSearchCheak(true);
  };
  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: '100vw',
            boxSizing: 'border-box',
            minWidth: '100%'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                OPD Artificial Manual Override
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setmedicineDetailList([]);
                    setDiagnos([]);
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id} `, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={0.8}>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.2, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Consultant</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8 }}
                      name="consultant"
                      placeholder="Select Consultant"
                      menus={doctorDropdown.map((data) => ({ ...data, name: data.name }))}
                      onChange={({ target: { row } }) => {
                        setValue('department', row.qualification_details.department);
                        setSelectedDepartment(row.qualification_details.department);
                        setSelectedDepartmentCheck(true);
                      }}
                    />
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Department</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.7 }}
                      name="department"
                      placeholder="Select Department"
                      disabled
                      menus={departmentDropdown.map((data) => ({ ...data, name: data.department }))}
                    />
                  </Stack>
                </Grid>

                <Grid item xs={4} sx={{ display: 'flex', gap: 0.2, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Male%</Typography>
                    <TextField
                      sx={{ flex: 0.4 }}
                      placeholder="Enter Male Percent"
                      name="male_per"
                      type="number"
                      disabled={!['new', 'edit'].includes(currentAction)}
                    />
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Female%</Typography>
                    <TextField
                      sx={{ flex: 0.4 }}
                      placeholder="Enter Adult Percent"
                      name="female_per"
                      type="number"
                      disabled={!['new', 'edit'].includes(currentAction)}
                    />
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>New%</Typography>
                    <TextField
                      sx={{ flex: 0.4 }}
                      placeholder="Enter New Percent"
                      name="new_per"
                      type="number"
                      disabled={!['new', 'edit'].includes(currentAction)}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.2, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Old%</Typography>
                    <TextField
                      sx={{ flex: 0.4 }}
                      placeholder="Enter Old Percent"
                      name="old_per"
                      type="number"
                      disabled={!['new', 'edit'].includes(currentAction)}
                    />
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Adult%</Typography>
                    <TextField
                      sx={{ flex: 0.4 }}
                      placeholder="Enter Adult Percent"
                      name="adult_per"
                      type="number"
                      disabled={!['new', 'edit'].includes(currentAction)}
                    />
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Child%</Typography>
                    <TextField
                      sx={{ flex: 0.4 }}
                      placeholder="Enter Child Percent"
                      name="child_per"
                      type="number"
                      disabled={!['new', 'edit'].includes(currentAction)}
                    />
                  </Stack>
                </Grid>

                <Grid item xs={4} sx={{ display: 'flex', gap: 0.2, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.17, fontWeight: 700, fontSize: '1.4rem' }}>Date From</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      type="date"
                      name="date_from"
                    />
                  </Stack>
                </Grid>

                <Grid item xs={4} sx={{ display: 'flex', gap: 0.2, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.1, fontWeight: 700, fontSize: '1.4rem' }}>Unit</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.9 }}
                      placeholder="Select Unit"
                      name="unit"
                      disabled={!['new', 'edit'].includes(currentAction)}
                      menus={unitDropdown.map((data) => ({ ...data, name: data?.unit }))}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.2, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Time From</Typography>
                    <TextField
                      sx={{ flex: 0.82 }}
                      placeholder="Enter Female Percent"
                      name="time_from"
                      disabled={!['new', 'edit'].includes(currentAction)}
                    />
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Time To</Typography>
                    <TextField sx={{ flex: 0.82 }} name="time_to" disabled={!['new', 'edit'].includes(currentAction)} />
                  </Stack>
                </Grid>
              </Grid>
              <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
                <MuiTextField
                  sx={{
                    width: '100%',
                    padding: 0,
                    '& .MuiInputBase-root': {
                      fontSize: '1.4rem', // Adjust the font size here
                      fontWeight: 700
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: '1.2rem' // Adjust label font size
                    }
                  }}
                  disabled={
                    !['new', 'edit'].includes(currentAction) || !departmentWatch
                  }
                  label="Search Service Name"
                  variant="outlined"
                  value={input}
                  onChange={handleChange}
                />
              </Stack>
              <ArtificialManualOverrideTable
                containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)', minHeight: '30rem', mt: 2 }}
                showOk={true}
                selectedSearchCheak={selectedSearchCheak}
                selectedRows={selectedRows}
                handleRowSelect={handleRowSelect}
                isSelected={isSelected}
                issLoading={issLoading}
                pagination={pagination}
                data={currentAction === 'new' ? serviceDropdown : []}
                columns={BILL_TABLE_HEADER}
                size="small"
                showInputField={true}
                handleInputChange={handleInputChange}
                fetchMoreDataSearch={fetchMoreDataSearch}
                fetchMoreData={fetchMoreData}
                selectedDepartmentCheck={selectedDepartmentCheck}
                selectedDepartment={selectedDepartment}
                input={input}
                onRowClick={(row) => {
                  setSelectedRecord(row);
                }}
              />
            </Box>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
